'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dAccepted$002dDrug$002dRequest$002dWithout$002dE$002dP$002dS$002dCode$002dNeeds$002dAttention from "./app.api.-General-Practice-App-Update$-Accepted-Drug-Request-Without-E-P-S-Code-Needs-Attention.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$62() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$62 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$62 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$62;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$62() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$62 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$62 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype.apply__Lapp_api_GeneralPracticeAppUpdate__Z = (function(a) {
  return ((a instanceof $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dAccepted$002dDrug$002dRequest$002dWithout$002dE$002dP$002dS$002dCode$002dNeeds$002dAttention.$c_Lapp_api_GeneralPracticeAppUpdate$AcceptedDrugRequestWithoutEPSCodeNeedsAttention) && (a !== null));
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_api_GeneralPracticeAppUpdate__Z(v1);
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$62.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_api_GeneralPracticeAppUpdate__Z(v1);
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$62 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$62, "app.api.GeneralPracticeAppUpdate$$anon$62", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$62: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$62 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$62 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$62.js.map
